import { app } from '../../../../../../app';
import { Controller } from './change-account-owner.controller';

app.component('companyUserDirectoriesManageAccountChangeOwnerConfirm', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./change-account-owner.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/owner/change/change-account-owner.component.js